import React from 'react';

/**
 * اختيار مكلَّف واحد أو أكثر. أوّل مكلَّف في القائمة هو الرئيسي —
 * وهو المرجع في التقارير والفلاتر، لذا يُعرض بوسم واضح.
 */
export default function AssigneePicker({ value = [], onChange, users = [] }) {
  const selectable = users.filter(u => ['admin', 'supervisor', 'team'].includes(u.role));
  const selected = value.map(id => selectable.find(u => String(u.id) === String(id))).filter(Boolean);
  const available = selectable.filter(u => !value.some(id => String(id) === String(u.id)));

  const add = (id) => { if (id) onChange([...value, Number(id)]); };
  const remove = (id) => onChange(value.filter(v => String(v) !== String(id)));
  const makePrimary = (id) => onChange([Number(id), ...value.filter(v => String(v) !== String(id))]);

  return (
    <div>
      {selected.length > 0 && (
        <div className="assignee-chips">
          {selected.map((u, i) => (
            <span key={u.id} className={`assignee-chip${i === 0 ? ' primary' : ''}`}>
              {i === 0 && <span title="المكلَّف الرئيسي">★</span>}
              {i > 0 && (
                <button type="button" title="اجعله المكلَّف الرئيسي" onClick={() => makePrimary(u.id)}>☆</button>
              )}
              {u.name}
              <button type="button" title="إزالة" onClick={() => remove(u.id)}>✕</button>
            </span>
          ))}
        </div>
      )}
      <select className="form-select" value="" onChange={e => add(e.target.value)}>
        <option value="">{selected.length ? '➕ إضافة مكلَّف آخر' : 'اختر مكلَّفاً'}</option>
        {available.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
      </select>
    </div>
  );
}
